import { ReactElement, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { TrainingPorgramsService } from 'services/TrainingProgramService';
import { Utils } from 'shared/helpers';
import AddTrainingPrograms from '../add-training-programs/Main';
import ExternalTrainingPrograms from '../add-external-traning-programs/Main';
import { Box, CircularProgress } from '@mui/material';

const EditTrainingProgram = (): ReactElement => {
  const { trainingId } = useParams();
  const [defaultData, setDefaultData] = useState<any>(null);
  const [hasExternalUrls, setHasExternalUrls] = useState<any>(0);
  const [loadingGetDetails, setLoadingGetDetails] = useState(true);

  useEffect(() => {
    if (trainingId) {
      TrainingPorgramsService.getTrainingProgramDetails(trainingId)
        .then((response) => {
          const { data } = response.data;

          setDefaultData(data.program_data);

          if (data.program_data.external_urls?.length > 0) {
            setHasExternalUrls(1);
          } else {
            setHasExternalUrls(2);
          }
          setLoadingGetDetails(false);
        })
        .catch((error) => {
          Utils.handleErrorResponse(error);
        });
    }
  }, [trainingId]);

  return (
    <>
      {loadingGetDetails && (
        <Box sx={{ alignSelf: 'center', textAlign: 'center' }}>
          <CircularProgress />
        </Box>
      )}
      {!loadingGetDetails && hasExternalUrls === 1 && (
        <ExternalTrainingPrograms purpose="editing" defaultData={defaultData} />
      )}
      {!loadingGetDetails && hasExternalUrls === 2 && (
        <AddTrainingPrograms purpose="editing" defaultData={defaultData} />
      )}
    </>
  );
};

export default EditTrainingProgram;
